import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import useDeleteProvidedJobPostList from '../api/useDeleteProvidedJobPostList';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  listId: string;
  listName: string;
  onDeleted?: () => void;
}

export default function DeleteListDialog({
  open,
  onOpenChange,
  listId,
  listName,
  onDeleted,
}: Props) {
  const { mutateAsync: deleteList, isPending } = useDeleteProvidedJobPostList();

  const handleSubmit = async () => {
    try {
      await deleteList({ id: listId });
      onOpenChange(false);
      showSuccessToast(`「${listName}」を削除しました`);
      onDeleted?.();
    } catch {
      alert('リストの削除に失敗しました');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[480px] rounded-sm">
        <DialogHeader>
          <DialogTitle>リストを削除</DialogTitle>
        </DialogHeader>

        <div className="p-lg">
          <DialogDescription>
            「{listName}」を削除しますか？この操作は取り消せません。
          </DialogDescription>
        </div>

        <DialogFooter>
          <div className="flex gap-2">
            <Button color="secondary" size="md" onClick={() => onOpenChange(false)}>
              キャンセル
            </Button>
            <Button color="danger" size="md" onClick={handleSubmit} disabled={isPending}>
              {isPending ? '削除中...' : 'リストを削除'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
